export default __webpack_public_path__ + "locales/pt-BR/DownloadDialog.json?hash=9dcfbba43e66676f9809c0ab761423e8";